import entities from "./entities/de";
import globals from "./globals/de";
import pages from "./pages/de";
import enums from "./enums/de";

export default { entities, globals, pages, enums };
